import { Button } from '@progress/kendo-react-buttons';
import React, { useState } from 'react';
import FormNumericTextBox from './FormNumericTextBox';
import { FieldWrapper } from '@progress/kendo-react-form';

const FormCounter = (props) => {
  const [value, setValue] = useState(1);

  const changeValue = (event, delta) => {
    event.preventDefault();
    const newValue = value + delta;
    props.onChange({
      value: newValue
    })
    setValue(newValue);
  };

  console.log(props);

  return (
    <FieldWrapper className='form-counter' style={{ display: 'flex' }}>
      <Button className='k-button k-button-solid-primary k-button-icon' icon='minus' onClick={(e) => changeValue(e, -1)} style={{ marginTop: '48px' }} />
      <FormNumericTextBox {...props} value={value}  />
      <Button className='k-button k-button-solid-primary k-button-icon' icon='add' onClick={(e) => changeValue(e, 1)} style={{ marginTop: '48px' }} />
    </FieldWrapper>
  )
};

export default FormCounter;